import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@paypalcorp/pp-react';
import fetch from 'isomorphic-fetch';
import { Link } from 'react-router-dom';
import CategoryCard from './CategoryCard';
import CategoryToolTile from './CategoryToolTile';

const CategoryRow = props => {
  const {
    content = {},
    featured = [],
    viewAllText = '',
    fptiClick,
    fptiImpression,
    toolTileProps
  } = props;
  const directionality = toolTileProps?.app?.context?.locale?.directionality;
  const handleClickCategory = fptiLink => {
    // fpti link is either the category/section OR 'viewall'
    // if 'viewall': pass 'viewall to handleClickCategory'
    fptiClick({
      fptiLink:
        (typeof fptiLink === 'string' && fptiLink) || content.categoryFPTI,
      category: 'parent',
      pageLink: content.categoryFPTI
    });
    fetch(content.PSClickUrl);
  };

  const handleClickTool = ({
    fptiLink,
    prod,
    PSUrl,
    categoryRank,
    appKey,
    rank,
    priorityScore
  }) => {
    return () => {
      fptiClick({
        fptiLink,
        prod,
        pageLink: content.categoryFPTI,
        categoryRank,
        appKey,
        rank,
        priorityScore
      });
      fetch(PSUrl);
    };
  };

  const chevronIcon =
    directionality === 'rtl' ? 'chevron-left' : 'chevron-right';
  return (
    <div className="appcenter-category">
      <div className="category-header">
        <h3>{content.categoryTitle}</h3>
        <div>
          <Link
            onClick={() => handleClickCategory('viewall')}
            to={`/appcenter/${content.location}`}
          >
            {viewAllText}
            <Icon size="sm" name={chevronIcon} />
          </Link>
        </div>
      </div>
      <div className="category-row">
        <CategoryCard
          content={content}
          handleClick={handleClickCategory}
          fptiImpression={fptiImpression}
        />
        {featured.map((tool, index) => (
          <CategoryToolTile
            key={`category-row-tool-${index}`}
            handleClickTool={handleClickTool}
            tool={tool}
            path={`/appcenter/${content.location}`}
            fptiImpression={fptiImpression}
            toolTileProps={toolTileProps}
          />
        ))}
      </div>
    </div>
  );
};

CategoryRow.propTypes = {
  featured: PropTypes.array,
  content: PropTypes.object,
  fptiClick: PropTypes.func,
  viewAllText: PropTypes.string,
  fptiImpression: PropTypes.func,
  toolTileProps: PropTypes.object,
  app: PropTypes.object
};

export default CategoryRow;
